import axios from "axios";
import Accordion from "../../../components/Accordion";
import React, { useState, useEffect, useMemo } from "react";
import ErrorHandler from "../../../components/core/ErrorHandler";
import { LoadingSpinner } from "../../../components/layout/LoadingSpinner";
import { DetailsModal } from "../../../components/grid/DetailsModal";
import { Row, Col } from "react-bootstrap";
import RxLookupForm from "./RxLookupForm";

import "font-awesome/css/font-awesome.min.css";

import { GridColumn } from "@progress/kendo-react-grid";
import { Button, DropDownButton } from "@progress/kendo-react-buttons";

import { FormatToCurrency } from "shared/helpers/MoneyHelpers";
import { ShortDateFormat, StringToDate } from "shared/helpers/DateHelpers";

import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import {
  MoneyCell,
  AggregateMoneyFooterCell,
  TooltipCellWithOptions,
} from "../../../components/grid/Kendo/CustomKendoGridCells";
import { ZIndexContext } from "@progress/kendo-react-common";
import { IgnoreModal } from "shared/components/ignoreModal/IgnoreModal";
import { IgnoreBody } from "shared/components/ignoreModal/IgnoreBody";
import IgnoreOptions from "shared/components/ignoreModal/IgnoreOptions";
import { GetDataWithCleanedDates } from "shared/helpers/DateHelpers.js";
import SingleCheckExcelExportWrapper from "../../../components/export/SingleCheckExcelExportWrapper";
import SingleCheckPdfExportWrapper from "../../../components/export/SingleCheckPdfExportWrapper";
import "./RxLookup.css";

import {
  DefaultColumnWidth,
  DefaultDateColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
  DefaultNoFilterColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import { useReactQueryHelpers } from "shared/hooks/useReactQueryHelpers";

import useGridDataStateResetProcessing from "shared/hooks/useGridDataStateResetProcessing";
import { RxLookupApiEndpoints } from "./RxLookupConstants";
import RxLookupMatchModal from "./RxLookupMatchModal";

export default function RxLookup(props) {
  const { passedProps } = props;
  const user = passedProps.user.email;

  const { invalidateReactQueryKey } = useReactQueryHelpers();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [expanded, setExpanded] = useState(false);

  const [submittedFormData, setSubmittedFormData] = useState(null);
  //const [mainGridData, setMainGridData] = useState([]);

  const mainGridAggregateColumnSettings = [
    { aggregate: "sum", field: "promiseToPay" },
    { aggregate: "sum", field: "paidAmount" },
  ];

  const [mainGridAggregates, setMainGridAggregates] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [detailsModalInputParameters, setDetailsModalInputParameters] =
    useState({});
  const [detailGridCheckData, setDetailGridCheckData] = useState(null);
  const [detailModalClaimData, setDetailModalClaimData] = useState({});
  const [detailError, setDetailError] = useState({});
  const [
    detailGridMoneyColumnAggregateSettings,
    setDetailGridMoneyColumnAggregateSettings,
  ] = useState([]);
  const [detailGridAggregates, setDetailGridAggregates] = useState([]);

  const [matchModalClaim, setMatchModalClaim] = useState(null);

  const [showIgnoreModal, setShowIgnoreModal] = useState(false);
  const [showFeesAndAdjustmentModal, setShowFeesAndAdjustmentModal] =
    useState(false);
  // const [feesAndAdjustmentData, setFeesAndAdjustmentData] = useState(null);
  const [IgnoreError, setIgnoreError] = useState({});
  const [selectedIgnoreOption, setSelectedIgnoreOption] = useState("");
  const [ignoreNote, setIgnoreNote] = useState("");
  const [selectedNcpdpIgnoreModalText, setSelectedNcpdpIgnoreModalText] =
    useState("");
  const [selectedRxIgnoreModalText, setSelectedRxIgnoreModalText] =
    useState("");
  const [
    claimLevelFeeAndAdjustmentsParameters,
    setClaimLevelFeeAndAdjustmentsParameters,
  ] = useState({});

  const {
    gridDataStateResetProcessingInitiated,
    InitiateGridDataStateReset,
    GridDataStateResetCompleted: onGridDataStateResetCompleted,
  } = useGridDataStateResetProcessing();

  const _container = React.useRef();
  let defaultColumnWidth = DefaultColumnWidth();

  const sendAggregatesToParent = (aggregatesFromSharedMainAgingGrid) => {
    setMainGridAggregates(aggregatesFromSharedMainAgingGrid.data);
  };

  const sendDetailAggregatesToParent = (aggregatesFromSharedTotalSalesGrid) => {
    setDetailGridAggregates(aggregatesFromSharedTotalSalesGrid.data);
  };

  const sendAccordionParent = (props) => {
    setExpanded(props);
  };

  function handleFormSubmit(formInput) {
    InitiateGridDataStateReset();
    setSubmittedFormData(formInput);
  }

  const clientGridApiParams = useMemo(() => {
    if (!submittedFormData) {
      return {};
    }

    return {
      user: user,
      rxNumber: submittedFormData.rxNumber,
      payers: submittedFormData.payers,
      locations: submittedFormData.locations,
      fromDate: submittedFormData.fromDate,
      toDate: submittedFormData.toDate,
      dateType: submittedFormData.dateType,
      bin: submittedFormData.bin,
      ndc: submittedFormData.ndc,
      patientLastName: submittedFormData.patientLastName,
    };
  }, [submittedFormData]);

  function getDetailsModalClaimsData(clid, pyid, rxNumber, mmid) {
    if (clid || pyid) {
      try {
        let accessToken = passedProps.auth.getAccessToken();

        axios
          .get(RxLookupApiEndpoints.GetClaimDetailsData, {
            params: {
              user: user,
              clid: clid,
              pyid: pyid,
              mmid: mmid,
            },
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          .then(onDetailsModalSuccess)
          .catch(onFailure);
      } catch (exception) {
        onFailure(exception);
      }
    }
  }

  function getFeesAndAdjustmentData(clid, pyid, rxNumber, mmid) {
    if (clid || pyid) {
      let parameters = {
        user: user,
        clid: clid,
        pyid: pyid,
        mmid: mmid,
        rxNumber: rxNumber,
      };

      setClaimLevelFeeAndAdjustmentsParameters(parameters);
    }
  }

  function onDetailsModalSuccess(response) {
    switch (response.config.url) {
      case RxLookupApiEndpoints.GetClaimDetailsData:
        presentDetailsClaimData(response.data);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (detailModalClaimData && detailGridCheckData) {
      setShowModal(true);
      setIsLoading(false);
    }
  }, [detailGridCheckData, detailModalClaimData]);

  function onFailure(error) {
    setIsLoading(false);

    switch (error.response.config.url) {
      case RxLookupApiEndpoints.Get:
        setError(error);
        break;
      case RxLookupApiEndpoints.GetClaimDetailsData:
        setDetailError(error);
        break;
      case "api/AgingDetails/IgnoreClaims":
        setDetailError(error);
        break;
      default:
        break;
    }

    return;
  }

  function presentDetailsClaimData(data) {
    if (data.dispenseDate) {
      data.dispenseDate = ShortDateFormat(data.dispenseDate);
    }
    if (data.transactionDate) {
      data.transactionDate = ShortDateFormat(data.transactionDate);
    }
    if (data.ignoreDate) {
      data.ignoreDate = ShortDateFormat(data.ignoreDate);
    }

    setDetailModalClaimData(data);
    setIsLoading(false);
  }

  const clientGridCheckDetailsApiParams = useMemo(() => {
    if (!detailsModalInputParameters) {
      return {};
    }

    let params = {
      user: user,
      clid: detailsModalInputParameters.clid,
      pyid: detailsModalInputParameters.pyid,
      mmid: detailsModalInputParameters.mmid,
      rxNumber: detailsModalInputParameters.rxNumber,
    };

    getDetailsModalClaimsData(
      detailsModalInputParameters.clid,
      detailsModalInputParameters.pyid,
      detailsModalInputParameters.rxNumber,
      detailsModalInputParameters.mmid
    );

    return params;
  }, [detailsModalInputParameters]);

  const RxLookupActionCell = (props) => {
    async function viewClick(event) {
      //NOTE: We're setting this for later retrieval following a claim ignore action
      // console.log(props.dataItem);
      setDetailsModalInputParameters(props.dataItem);

      setShowModal(true);
    }

    function matchClick() {
      setMatchModalClaim(props.dataItem);
    }

    const linkStyle = {
      cursor: "pointer",
      textDecoration: "underline",
      color: "#015CAB",
    };

    return (
      <td className="noWrap" {...props.style}>
        <a onClick={viewClick} style={linkStyle}>
          View
        </a>
        {props.dataItem.rxNumber && props.dataItem.mmid && (
          <React.Fragment>
            {" | "}
            <a onClick={matchClick} style={linkStyle}>
              Match/Unmatch
            </a>
          </React.Fragment>
        )}
      </td>
    );
  };

  const MainGridAggregateMoneyFooterCell = (props) => {
    var options = {
      aggregateData: mainGridAggregates,
    };

    return AggregateMoneyFooterCell(props, options);
  };

  let DetailsGridAggregateMoneyCell = (props) => {
    var options = {
      aggregateData: detailGridAggregates,
    };
    return AggregateMoneyFooterCell(props, options);
  };

  function showFeesAndAdjustments() {
    setShowModal(false);
    setShowFeesAndAdjustmentModal(true);
    getFeesAndAdjustmentData(
      detailsModalInputParameters.clid,
      detailsModalInputParameters.pyid,
      detailsModalInputParameters.rxNumber,
      detailsModalInputParameters.mmid
    );
  }

  function addEditIgnoreDetails(event) {
    if (!detailModalClaimData.clid) {
      alert("There is no claim data to ignore.");
    } else {
      setShowModal(false);
      setIgnoreNote("");
      setSelectedIgnoreOption("");

      setSelectedNcpdpIgnoreModalText(detailModalClaimData.ncpdp);
      setSelectedRxIgnoreModalText(detailModalClaimData.rxNumber);
      setShowIgnoreModal(true);
    }
  }

  async function unIgnoreClick() {
    if (window.confirm("Do you want to unignore the claim?")) {
      let accessToken = passedProps.auth.getAccessToken();

      let ignoreParameters = {
        user: user,
        IgnoreId: "0",
        IgnoreNote: "",
        ClaimIds: detailsModalInputParameters.clid,
      };

      setIsLoading(true);

      const response = await axios
        .get("api/AgingDetails/UnIgnoreClaims", {
          params: ignoreParameters,
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then(refetchClaimsDetailsData)
        .catch(onFailure);

      async function refetchClaimsDetailsData(ignoreResponse) {
        invalidateReactQueryKey(RxLookupApiEndpoints.Get);
        await axios
          .get(RxLookupApiEndpoints.GetClaimDetailsData, {
            params: {
              user: user,
              clid: detailsModalInputParameters.clid,
              pyid: detailsModalInputParameters.pyid,
              mmid: detailsModalInputParameters.mmid,
            },
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          .then(onDetailsModalSuccess)
          .catch(onFailure);
      }
    }
  }

  const onIgnoreClaimsSaveButtonCallback = () => {
    setIsLoading(true);
  };

  async function refetchClaimsDetailsData(ignoreResponse) {
    let accessToken = passedProps.auth.getAccessToken();

    await axios
      .get(RxLookupApiEndpoints.GetClaimDetailsData, {
        params: {
          user: user,
          clid: detailsModalInputParameters.clid,
          pyid: detailsModalInputParameters.pyid,
          mmid: detailsModalInputParameters.mmid,
        },
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then(onDetailsModalSuccess)
      .catch(onFailure);
  }

  const onIgnoreClaimSuccessCallback = (response) => {
    setIsLoading(false);
    hideAndResetIgnoreModal();
    refetchClaimsDetailsData(response);
    invalidateReactQueryKey(RxLookupApiEndpoints.Get);
  };

  function hideAndResetIgnoreModal() {
    setShowIgnoreModal(false);
    setIgnoreError({});
    setSelectedIgnoreOption("");
    setIgnoreNote("");
    setSelectedNcpdpIgnoreModalText("");
    setSelectedRxIgnoreModalText("");
    setShowModal(true);
  }

  function hideFeesAndAdjustments() {
    setShowFeesAndAdjustmentModal(false);
    // setFeesAndAdjustmentData([]);
    setShowModal(true);
  }

  function getReadableIgnoreReason(ignoreReason) {
    try {
      let ignoreOptionOfClaim = IgnoreOptions.find((x) => {
        return x.value == ignoreReason;
        Accordion;
      });

      if (
        ignoreOptionOfClaim != null &&
        ignoreOptionOfClaim.label.trim() == ""
      ) {
        return ignoreReason + "-" + ignoreOptionOfClaim.label;
      } else {
        return ignoreReason;
      }
    } catch (e) {
      console.log(e);
      return ignoreReason;
    }
  }

  const DetailsModalDownloadCell = (props) => (
    <CustomCell {...props} color={"#015CAB"} />
  );
  const downloadButtonItems = ["Excel", "PDF"];

  const CustomCell = (props) => {
    async function downloadClick(event) {
      const accessToken = await passedProps.auth.getAccessToken();

      if (event.item === "Excel") {
        await SingleCheckExcelExportWrapper(
          props.dataItem.pmid,
          accessToken,
          setIsLoading
        );
      } else if (event.item === "PDF") {
        await SingleCheckPdfExportWrapper(
          props.dataItem.pmid,
          accessToken,
          setIsLoading
        );
      }
    }
    return (
      <td {...props.tdProps} colSpan={1}>
        {" "}
        <ZIndexContext.Provider value={10003}>
          <DropDownButton
            text={
              <span>
                <i className="fa fa-download" aria-hidden></i> Download{" "}
              </span>
            }
            items={downloadButtonItems}
            themeColor={"primary"}
            fillMode={"link"}
            onItemClick={downloadClick}
          />
        </ZIndexContext.Provider>
      </td>
    );
  };

  function handleDetailsModalClose() {
    setShowModal(false);
  }

  return (
    <React.Fragment>
      <div className="feature">
        <LoadingSpinner isDataLoading={isLoading} controlsName={"RxLookup"} />
        <ErrorHandler
          error={error}
          onClose={() => {
            setError({});
          }}
        />
        <Accordion
          defaultExpanded
          label="Search & Filter"
          sendAccordionParentCallback={sendAccordionParent}
        >
          <Row>
            <Col md="auto" className="d-flex flex-column higher-zindex-filters">
              <RxLookupForm handleFormSubmit={handleFormSubmit}></RxLookupForm>
            </Col>
          </Row>
        </Accordion>

        <div ref={_container}>
          <Row>
            <Col className="tight-grid multi-line-filter">
              <br />
              <SharedMainSelectableClientGrid
                apiGetEndpoint={RxLookupApiEndpoints.Get}
                apiParameters={clientGridApiParams}
                aggregateColumnSettings={mainGridAggregateColumnSettings}
                sendAggregatesParentCallback={sendAggregatesToParent}
                styleOverride={{ minHeight: "19em", maxHeight: "50em" }}
                exportFileNamePrefix={"RxLookupExport"}
                gridDataStateResetProcessingInitiated={
                  gridDataStateResetProcessingInitiated
                }
                onGridDataStateResetCompleted={onGridDataStateResetCompleted}
              >
                <GridColumn
                  field=""
                  title="Action"
                  filterable={false}
                  sortable={false}
                  groupable={false}
                  width={DefaultNoFilterColumnWidth()}
                  cells={{ data: RxLookupActionCell }}
                />
                <GridColumn
                  field="rxNumber"
                  title="Rx Number"
                  width={defaultColumnWidth}
                />
                <GridColumn
                  field="ncpdp"
                  title="NCPDP"
                  width={DefaultBooleanOrShortWidthColumnWidth()}
                />
                <GridColumn
                  field="dispenseDate"
                  title="Dispense Date"
                  filter="date"
                  format="{0:d}"
                  width={DefaultDateColumnWidth()}
                />
                <GridColumn
                  field="transactionDate"
                  title="Transaction Date"
                  filter="date"
                  format="{0:d}"
                  width={DefaultDateColumnWidth()}
                />
                <GridColumn
                  field="payerName"
                  title="Payer Name"
                  width={defaultColumnWidth}
                />
                <GridColumn
                  field="promiseToPay"
                  title="Promise To Pay"
                  format="{0:c}"
                  filter="numeric"
                  headerCell={(props) => (
                    <TooltipCellWithOptions {...props} options={{
                      toolTip: "If payer is a mfg. then the amount shown is the SDRA amount."
                    }} />
                  )}
                  cells={{
                    data: MoneyCell,
                    footerCell: MainGridAggregateMoneyFooterCell,
                  }}
                  width={defaultColumnWidth}
                />
                <GridColumn
                  field="paidAmount"
                  title="Paid Amount"
                  format="{0:c}"
                  filter="numeric"
                  cells={{
                    data: MoneyCell,
                    footerCell: MainGridAggregateMoneyFooterCell,
                  }}
                  width={defaultColumnWidth}
                />
                <GridColumn
                  field="reconciled"
                  title="Reconciled"
                  width={DefaultBooleanOrShortWidthColumnWidth()}
                />
                <GridColumn
                  field="ignoreFlag"
                  title="Ignore Flag"
                  width={DefaultBooleanOrShortWidthColumnWidth()}
                />

                <GridColumn
                  field="ignoreDate"
                  title="Ignore Date"
                  filter="date"
                  format="{0:d}"
                  width={DefaultDateColumnWidth()}
                />

                <GridColumn
                  field="ignoreCode"
                  title="Ignore Code"
                  width={DefaultDateColumnWidth()}
                />

                <GridColumn
                  field="ignoreReason"
                  title="Ignore Reason"
                  width={DefaultColumnWidth()}
                />
                <GridColumn
                  field="ignoreUser"
                  title="Ignored User"
                  hidden={false}
                  width={0}
                />
                <GridColumn
                  field="adjustedByPharmacyUser"
                  title="Adjusted By"
                  width={defaultColumnWidth}
                />
              </SharedMainSelectableClientGrid>
            </Col>
          </Row>
        </div>

        {matchModalClaim && (
          <RxLookupMatchModal
            claim={matchModalClaim}
            onClose={() => setMatchModalClaim(null)}
          />
        )}

        <DetailsModal
          title="Rx Details"
          show={showModal}
          handleClose={() => handleDetailsModalClose()}
        >
          <ErrorHandler
            error={detailError}
            onClose={() => {
              setDetailError({});
            }}
          />
          <ZIndexContext.Provider value={10003}>
            <canvas
              id="hiddenCanvasForSingleCheckPdf"
              style={{ display: "none" }}
              width={185}
              height={70}
            />
            <Row className="details-modal-row modal-label">
              <Col md="2" className="d-flex flex-column">
                Rx Number:
              </Col>
              <Col md="2" className="d-flex flex-column">
                NCPDP:
              </Col>
              <Col md="2" className="d-flex flex-column">
                BIN:
              </Col>
              <Col md="2" className="d-flex flex-column">
                PCN:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Payer Name:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Quantity:
              </Col>
            </Row>
            <Row className="details-modal-row">
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.rxNumber}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.ncpdp}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.bin}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.pcn}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.payerName}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.quantity}
              </Col>
            </Row>
            <Row className="details-modal-row modal-label">
              <Col md="2" className="d-flex flex-column">
                NDC:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Adjudicated:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Paid:
              </Col>
              <Col md="2" className="d-flex flex-column">
                CoPay:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Dispense Date:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Transaction Date:
              </Col>
            </Row>
            <Row className="details-modal-row">
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.ndc}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {FormatToCurrency(detailModalClaimData.adjudicatedAmount)}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {FormatToCurrency(detailModalClaimData.paidAmount)}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {FormatToCurrency(detailModalClaimData.coPay)}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.dispenseDate}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.transactionDate}
              </Col>
            </Row>
            <Row className="details-modal-row modal-label">
              <Col md="2" className="d-flex flex-column">
                Cardholder ID:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Auth Code:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Reconciled:
              </Col>
              <Col md="2" className="d-flex flex-column">
                Follow Ups:
              </Col>
            </Row>
            <Row className="details-modal-row">
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.cardHolderId}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.authCode}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.reconciled}
              </Col>
              <Col md="2" className="d-flex flex-column">
                {detailModalClaimData.letter_htm}
              </Col>
            </Row>
            <Row>
              <Col md="4" className="d-flex flex-column">
                <Button
                  onClick={showFeesAndAdjustments}
                  style={{
                    backgroundColor: "#015cab",
                    color: "white",
                  }}
                >
                  Show Claim Level Fees & Adjustments
                </Button>
              </Col>
            </Row>
            <h4>Associated Checks</h4>
            <Row>
              <Col className="tight-grid multi-line-filter">
                <SharedMainSelectableClientGrid
                  apiGetEndpoint={RxLookupApiEndpoints.GetCheckDetailsData}
                  apiParameters={clientGridCheckDetailsApiParams}
                  aggregateColumnSettings={
                    detailGridMoneyColumnAggregateSettings
                  }
                  sendAggregatesParentCallback={sendDetailAggregatesToParent}
                  scrollType="scrollable"
                  styleOverride={{ height: "500px" }}
                  exportFileNamePrefix={"RxLookupCheckDetailsExport"}
                >
                  <GridColumn
                    key={"PMID"}
                    field={"PMID"}
                    title={"Download Report"}
                    filterable={false}
                    cells={{
                      data: DetailsModalDownloadCell,
                    }}
                    width={defaultColumnWidth}
                  />
                  <GridColumn
                    key={"Payer"}
                    field={"payer"}
                    title={"Payer"}
                    width={defaultColumnWidth}
                  />
                  <GridColumn
                    key={"CheckNumber"}
                    field={"checkNumber"}
                    title={"Check Number"}
                    width={defaultColumnWidth}
                  />
                  <GridColumn
                    key={"CheckDate"}
                    field={"checkDate"}
                    title={"Check Date"}
                    width={DefaultDateColumnWidth()}
                    filter={"date"}
                    format="{0:d}"
                  />
                  <GridColumn
                    key={"CheckArchiveDate"}
                    field={"checkArchiveDate"}
                    title={"Check Archive Date"}
                    width={DefaultDateColumnWidth()}
                    filter={"date"}
                    format="{0:d}"
                  />
                  <GridColumn
                    key={"PaidAmount"}
                    field={"paid"}
                    title={"Remittance Paid"}
                    width={defaultColumnWidth}
                    filter={"numeric"}
                    cells={{
                      data: MoneyCell,
                      footerCell: DetailsGridAggregateMoneyCell,
                    }}
                    footerCell={DetailsGridAggregateMoneyCell}
                  />
                  <GridColumn
                    key={"PaymentType"}
                    field={"paymentType"}
                    title={"Payment Type"}
                    width={defaultColumnWidth}
                  />
                </SharedMainSelectableClientGrid>
              </Col>
            </Row>

            <Row>
              <Col md="auto" className="d-flex flex-column">
                <Button
                  onClick={addEditIgnoreDetails}
                  style={{
                    backgroundColor: "#015cab",
                    color: "white",
                  }}
                >
                  Ignore Claim/Edit Ignore Details
                </Button>
              </Col>

              <Col md="auto" className="d-flex flex-column">
                <Button
                  onClick={unIgnoreClick}
                  style={{
                    backgroundColor: "#015cab",
                    color: "white",
                  }}
                >
                  UnIgnore Claim
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12" className="d-flex flex-column">
                <div>
                  Is Claim Ignored? &nbsp;
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {detailModalClaimData.ignoreFlag === "Y" ? "Yes" : "No"}
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="12" className="d-flex flex-column">
                Ignored Reason Code:{" "}
                {detailModalClaimData.ignoreReason
                  ? getReadableIgnoreReason(detailModalClaimData.ignoreReason)
                  : ""}
              </Col>
            </Row>
            <Row>
              <Col md="12" className="d-flex flex-column">
                Ignored Claim Note: {detailModalClaimData.ignoreNote}
              </Col>
            </Row>
            <Row>
              <Col md="6" className="d-flex flex-column">
                Ignored User: {detailModalClaimData.ignoreUser}
              </Col>
              <Col md="6" className="d-flex flex-column">
                Ignored Date: {detailModalClaimData.ignoreDate}
              </Col>
            </Row>
          </ZIndexContext.Provider>
        </DetailsModal>

        <IgnoreModal
          title="Ignore From Aging"
          show={showIgnoreModal}
          handleClose={() => hideAndResetIgnoreModal()}
        >
          <ErrorHandler
            error={IgnoreError}
            onClose={() => {
              setIgnoreError({});
            }}
          />

          <IgnoreBody
            selectedNcpdpIgnoreModalText={selectedNcpdpIgnoreModalText}
            selectedRxIgnoreModalText={selectedRxIgnoreModalText}
            handleCancelClick={hideAndResetIgnoreModal}
            selectedClidsToIgnore={detailsModalInputParameters.clid}
            onSaveButtonClickCallbackFromParent={
              onIgnoreClaimsSaveButtonCallback
            }
            onSuccessCallbackFromParent={onIgnoreClaimSuccessCallback}
          ></IgnoreBody>
        </IgnoreModal>

        <DetailsModal
          title="Claim Level Fees & Adjustments"
          show={showFeesAndAdjustmentModal}
          handleClose={() => hideFeesAndAdjustments()}
        >
          <ZIndexContext.Provider value={10004}>
            <Row>
              <Col md="12" className="tight-grid multi-line-filter">
                <SharedMainSelectableClientGrid
                  apiGetEndpoint={
                    RxLookupApiEndpoints.GetClaimLevelFeeAndAdjustmentsData
                  }
                  apiParameters={claimLevelFeeAndAdjustmentsParameters}
                  scrollType="scrollable"
                  styleOverride={{ height: "500px" }}
                  exportFileNamePrefix={
                    "RxLookupClaimLevelFeesAndAdjustmentsExport"
                  }
                >
                  <GridColumn
                    field="payer"
                    title="Payer"
                    width={DefaultColumnWidth()}
                  />
                  <GridColumn
                    field="checkNumber"
                    title="Check Number"
                    width={DefaultColumnWidth()}
                  />
                  <GridColumn
                    key={"ncpdp"}
                    field={"ncpdp"}
                    title={"NCPDP"}
                    filter={"text"}
                    width={DefaultBooleanOrShortWidthColumnWidth()}
                  />

                  <GridColumn
                    key={"checkDate"}
                    field={"checkDate"}
                    title={"Check Date"}
                    filter={"date"}
                    format="{0:d}"
                    width={DefaultDateColumnWidth()}
                  />

                  <GridColumn
                    key={"checkAmount"}
                    field={"checkAmount"}
                    title={"Check Amount"}
                    filter={"text"}
                    width={DefaultColumnWidth()}
                    cells={{
                      data: MoneyCell,
                    }}
                  />
                  <GridColumn
                    key={"rxNumber"}
                    field={"rxNumber"}
                    title={"Rx #"}
                    filter={"text"}
                    width={DefaultColumnWidth()}
                  />
                  <GridColumn
                    key={"fillDate"}
                    field={"fillDate"}
                    title={"Fill Date"}
                    filter={"date"}
                    format="{0:d}"
                    width={DefaultDateColumnWidth()}
                  />
                  <GridColumn
                    key={"transactionDate"}
                    field={"transactionDate"}
                    title={"Transaction Date"}
                    filter={"date"}
                    format="{0:d}"
                    width={DefaultDateColumnWidth()}
                  />
                  <GridColumn
                    key={"patientName"}
                    field={"patientName"}
                    title={"Patient Name"}
                    filter={"text"}
                    width={DefaultColumnWidth()}
                  />
                  <GridColumn
                    key={"feeAdjustmentAmount"}
                    field={"feeAdjustmentAmount"}
                    title={"Fee/Adjustment Amount"}
                    filter={"numeric"}
                    width={DefaultColumnWidth()}
                    cells={{
                      data: MoneyCell,
                    }}
                  />
                  <GridColumn
                    key={"reasonCode"}
                    field={"reasonCode"}
                    title={"Reason Code"}
                    filter={"text"}
                    width={DefaultColumnWidth()}
                  />
                  <GridColumn
                    key={"reasonDescription"}
                    field={"reasonDescription"}
                    title={"Reason Description"}
                    filter={"text"}
                    width={DefaultColumnWidth()}
                  />
                </SharedMainSelectableClientGrid>
              </Col>
            </Row>
          </ZIndexContext.Provider>
        </DetailsModal>
      </div>
    </React.Fragment>
  );
}
